var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKnc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 256c70.692 0 128-57.308 128-128C256 57.308 198.692 0 128 0 57.308 0 0 57.307 0 128c0 70.692 57.307 128 128 128Z",
    fill: "#6C8275"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m118.179 128.005 69.288 39.689a3.662 3.662 0 0 0 3.697.043 3.657 3.657 0 0 0 1.846-3.203V91.421a3.637 3.637 0 0 0-1.844-3.207 3.632 3.632 0 0 0-3.699.075l-69.288 39.716Zm67.819-57.288-47.366-34.838a3.764 3.764 0 0 0-5.037.405c-.424.45-.731.998-.894 1.595l-17.294 77.599 70.175-38.8a3.497 3.497 0 0 0 1.887-2.862 3.497 3.497 0 0 0-1.471-3.097m-47.421 149.385 47.421-34.839a3.543 3.543 0 0 0 1.5-3.131 3.556 3.556 0 0 0-1.891-2.912l-70.2-38.8 17.294 77.6a3.746 3.746 0 0 0 4.185 2.836 3.755 3.755 0 0 0 1.691-.702",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m100.163 126.564 18.015-84.255a3.575 3.575 0 0 0-5.543-3.627L66.489 74.071a9.562 9.562 0 0 0-3.742 7.622v89.8a9.559 9.559 0 0 0 3.742 7.733l45.924 35.282a3.576 3.576 0 0 0 5.543-3.631l-17.793-84.313Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnc);
export default __webpack_public_path__ + "static/media/knc.0e35313769b7fc9ab730d7c750386c6f.svg";
export { ForwardRef as ReactComponent };